
import { CreateElement, VNode } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Selectable extends Vue {
  @Prop({default: false}) protected multiple!: boolean;
  @Prop({default: []}) protected input!: any[];
  @Prop({default: []}) protected selectedItems!: any[];

  protected render(h: CreateElement): VNode {
    if (this.$scopedSlots.default) {
      const that = this;
      return this.$scopedSlots.default!({
        selection: this.selectedItems.map((it) => it.data),
        items: this.input.map((d: any) => ({
          data: d,
          isSelected: null != that.selectedItems.find((it) => it.data === d),
        })),
        changeSelection: this.changeSelection,
      }) as any;
    } else {
      return h();
    }
  }
  protected isSelected(item: any) {
    return null != this.selectedItems.find((it) => it.data === item.data);
  }
  /**
   * Handle click event.
   * @param item object to change state
   * @param selection flag for selection of deselection, true if selection
   */
  protected changeSelection(item: any, selection: boolean) {
    if (selection) {
      if (this.multiple) {
        if (!this.selectedItems.includes(item)) {
          this.selectedItems.push(item);
        }
      } else {
        if (1 < this.selectedItems.length) {
          throw Error('Invalid State:' + this.selectedItems.length);
        }
        if (!this.isSelected(item)) {
          this.selectedItems.splice(0, this.selectedItems.length);
          this.selectedItems.push(item);
        }
      }
    } else {
      this.selectedItems
        .flatMap((it, index) => (it.data === item.data) ? [index] : [])
        .reverse()
        .forEach((index) => this.selectedItems.splice(index, 1), this);
    }
  }
}
